import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import type { EventPrefix } from "@/features/analytics/models";
import {
  CUSTOMER_IO_EVENT,
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";

interface TrackEmailPhonePageViewedParams {
  customerIoAnalytics: AnalyticsBrowser;
  eventPrefix?: EventPrefix;
}

export const trackEmailPhonePageViewed = ({
  customerIoAnalytics,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackEmailPhonePageViewedParams) => {
  triggerGoogleTagManagerTracking({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.EMAIL_PHONE_PAGE_VIEWED}`,
  });
  void customerIoAnalytics.track(
    `${eventPrefix}${CUSTOMER_IO_EVENT.EMAIL_PHONE_PAGE_VIEWED}`,
    {
      source: window.location.href,
    },
  );
};
